import type { CSSProperties } from "react";

interface GoldfinchLogoProps {
  className?: string;
  style?: CSSProperties;
}

export function GoldfinchLogo({ className, style }: GoldfinchLogoProps) {
  return (
    <svg
      viewBox="0 0 312 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      role="img"
      aria-label="Goldfinch">
      <path
        d="M124.761 51.7C124.761 46.03 120.461 41.79 115.121 41.79C109.781 41.79 105.481 46.03 105.481 51.7C105.481 57.37 109.721 61.67 115.171 61.67C120.621 61.67 124.751 57.37 124.751 51.7M99.3711 51.7C99.3711 42.89 106.311 36 115.181 36C124.051 36 130.881 42.89 130.881 51.7C130.881 60.51 123.991 67.45 115.181 67.45C106.371 67.45 99.3711 60.51 99.3711 51.7Z"
        fill="currentColor"
      />
      <path
        d="M142.121 26.09H136.061V66.73H142.121V26.09Z"
        fill="currentColor"
      />
      <path
        d="M172.681 51.7C172.681 45.92 168.491 41.73 163.101 41.73C157.711 41.73 153.411 45.91 153.411 51.7C153.411 57.49 157.591 61.67 163.101 61.67C168.611 61.67 172.681 57.48 172.681 51.7ZM172.681 63.49C170.151 65.97 166.681 67.46 162.601 67.46C153.731 67.46 147.291 60.52 147.291 51.71C147.291 42.9 153.731 35.96 162.601 35.96C166.671 35.96 170.141 37.45 172.681 39.93V26.11H178.741V66.75H172.681V63.5V63.49Z"
        fill="currentColor"
      />
      <path
        d="M196.59 26.09H200.89V32.09H196.59C193.51 32.09 192.02 33.96 192.02 35.89V36.66H200.89V42.55H192.02V66.73H185.91V35.89C185.91 30.27 190.26 26.09 196.59 26.09Z"
        fill="currentColor"
      />
      <path
        d="M205.242 36.67H211.302V66.74H205.242V36.67ZM205.182 26.09H211.352V32.2H205.182V26.09Z"
        fill="currentColor"
      />
      <path
        d="M232.001 41.73C227.591 41.73 224.511 44.76 224.511 49.17V66.74H218.451V36.67H224.511V40.19C226.441 37.6 229.581 36 233.161 36C240.151 36 245.001 41.23 245.001 48.89V66.73H238.941V48.89C238.941 44.65 236.081 41.73 232.001 41.73Z"
        fill="currentColor"
      />
      <path
        d="M249.361 51.7C249.361 42.89 256.301 35.95 265.171 35.95C272.821 35.95 278.771 40.8 279.871 47.9H273.541C272.601 44.16 269.241 41.73 265.171 41.73C259.721 41.73 255.421 46.03 255.421 51.7C255.421 57.37 259.711 61.67 265.171 61.67C269.191 61.67 272.601 59.25 273.541 55.56H279.871C278.711 62.66 272.771 67.46 265.171 67.46C256.301 67.46 249.361 60.52 249.361 51.71"
        fill="currentColor"
      />
      <path
        d="M284.611 26.09H290.671V40.19C292.651 37.54 295.851 36 299.591 36C306.751 36 311.711 41.23 311.711 48.89V66.74H305.601V48.89C305.601 44.65 302.681 41.73 298.441 41.73C293.871 41.73 290.681 44.76 290.681 49.16V66.73H284.621V26.09H284.611Z"
        fill="currentColor"
      />
      <path
        d="M63.7911 72.19H85.7711C89.4611 72.19 90.7811 74.17 90.7811 75.62C90.7811 77.06 89.4611 79.05 85.7711 79.05H58.9711L54.8711 84.94H87.0911C93.4211 84.94 96.8411 81.14 96.8411 75.62C96.8411 70.1 93.4211 66.3 87.0911 66.3H75.3011L78.8211 61.18C79.8711 61.46 81.0211 61.62 82.1811 61.62C89.3911 61.62 95.0111 56 95.0111 48.73C95.0111 46.08 94.2411 43.66 92.9211 41.63L97.3311 35.85L92.4811 32.33L88.5111 37.51C86.6411 36.52 84.5511 35.91 82.2311 35.91C75.1211 35.91 69.5111 41.58 69.5111 48.74C69.5111 52.65 71.0511 55.95 73.4811 58.27L63.7811 72.2L63.7911 72.19ZM82.2411 41.68C86.0411 41.68 89.0711 44.82 89.0711 48.67C89.0711 52.52 86.1011 55.77 82.2411 55.77C78.3811 55.77 75.4611 52.63 75.4611 48.67C75.4611 44.71 78.4311 41.68 82.2411 41.68Z"
        fill="currentColor"
      />
      <path
        d="M25.5918 0V16.8376L42.2287 29.6963L46.2259 24.4488L25.5918 0Z"
        fill="currentColor"
      />
      <path
        d="M47.7034 25.6078L42.8483 32.1969L4.67383 4.88245L9.60193 29.5047L16.5651 31.9596L10.624 33.9399L12.2759 41.6971L33.9138 44.3072L21.2194 61.5007C21.2194 61.5007 48.0958 47.3827 53.1882 31.1747L47.7125 25.5987L47.7034 25.6078Z"
        fill="currentColor"
      />
      <path
        d="M25.0055 52.7946L15.1949 66H9.9292L11.07 64.0562L6.68943 66H0L25.0055 52.7946Z"
        fill="currentColor"
      />
      <path
        d="M65.1968 26.9495L57.3848 26.9951L51.5259 21.5651C50.2939 22.4685 49.0162 23.7827 47.7021 25.6171L53.1777 31.1931C48.0945 47.401 21.209 61.5191 21.209 61.5191C21.209 61.5191 52.0278 52.9041 57.1111 36.6961L64.129 31.7863L70.9006 31.1931L65.1968 26.9586V26.9495Z"
        fill="#EEDA84"
      />
      <path
        d="M65.1969 26.9403C65.133 26.8217 59.3836 15.7791 51.5352 21.5559L57.3941 26.9859L65.206 26.9403H65.1969Z"
        fill="currentColor"
      />
    </svg>
  );
}
